<template>
	<a class="tip-jar-btn" :href="url" :title="title" target="_blank">
		<button class ="btn btn-secondary-outline btn-3d">
			<img class="tip-jar-img"
				src="~@/assets/coffee_mug_icon.png"
				alt="coffee mug icon"
			/>
			<div class="btn-text-content">
				<div class="tip-jar-title">{{ title }}</div>
				<div class="tip-jar-subtitle">{{ subtitle }}</div>
			</div>
			<fa-icon
				class="external-link-icon"
				icon="external-link"
			>
			</fa-icon>

		</button>
	</a>
</template>

<script>
export default {
    name: 'TipJar',
    props: {
        url: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
		subtitle: {
            type: String,
            required: false,
        },
    },
};
</script>

<style scoped lang="scss">
@use "@/styles/styles.scss" as *;

    .tip-jar-btn {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        vertical-align: middle;
        border-radius: 4px;
        padding: 6px 8px;
        text-decoration: none;

		.btn {
			display: flex;
			align-items: center;
            justify-content: space-between;
			gap: 8px;
		}

		.btn-text-content {
			display: flex;
			flex-direction: column;
			justify-content: center;
            flex: 1;
		}

        .tip-jar-title,
        .tip-jar-subtitle {
            line-height: 1.2;
            text-align: center;
            max-width: 180px;
            width: 100%;
            white-space: normal;
            overflow-wrap: break-word;
			font-size: .75rem;
        }

		.tip-jar-subtitle {
			font-weight: normal;
			font-size: .7rem;
			margin-top: 5px;
		}

        .tip-jar-img {
            max-height: 35px;
            height: auto;
            width: auto;
            align-self: center;
			display: none;
			margin-top: -5px;
        }

		.external-link-icon {
			width: 14px;
			height: 14px;
		}
    }

@media only screen and (min-width: $screen-xs) {
	.tip-jar-btn {

		// .btn {
		// 	width: 100%;
		// }

		.tip-jar-title,
		.tip-jar-subtitle {
			font-size: .85rem;
		}

		.tip-jar-subtitle {
			font-size: .75rem;
		}

		.external-link-icon {
			width: 16px;
			height: 16px;
		}

		.tip-jar-img {
			display: inline-block;
		}
	}
}
</style>
